export type Step = {
  slug: string;
  label: string;
};

export const getLineWidth = (currentStep: number, steps: Step[]) => {
  if (currentStep === 1) return '0%';

  const stepIndex = currentStep - 1;
  const totalSteps = steps.length - 1;
  const width = (stepIndex / totalSteps) * 100;

  return `${width}%`;
};
